// extracted by mini-css-extract-plugin
module.exports = {"news-page":"US_news-page__7e1nA"};